import "../css/Navbar.css";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Offcanvas, Nav, Navbar, Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import Menu from "./Menu";
import axios from "axios";

export default function MainNavbar() {
  const customer = useSelector((state) => state.customer);
  const shoppingCartSize = useSelector((state) =>
    state.shoppingCart.content.reduce(
      (numberOfProducts, product) => numberOfProducts + product.quantity,
      0,
    ),
  );
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [willMenuClose, setWillMenuClose] = useState(false);
  const [customerDropdown, setCustomerDropdown] = useState(false);
  const [categories, setCategories] = useState([]);
  const dispatch = useDispatch();
  const location = useLocation();
  const [navbarChange, setNavbarChange] = useState(location.pathname !== "/");

  const getCategories = async () => {
    try {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_API_URL}/categories`,
      });
      setCategories(response.data);
    } catch (err) {
      console.log(err.response.data.msg);
    }
  };
  const toggleCustomerDropdown = () => setCustomerDropdown(!customerDropdown);
  const openShoppingCart = () => dispatch({ type: "TOGGLE_CART_VISIBILITY" });
  const logout = async () => {
    setTimeout(() => {
      dispatch({ type: "CLEAR_CART" });
      dispatch({ type: "LOGOUT" });
      console.log("Logged out.");
    }, 750);
  };
  const toggleMenu = async () => {
    if (isMenuOpen) {
      setWillMenuClose(true);
      setTimeout(() => {
        setIsMenuOpen(false);
      }, 500);
    } else {
      setIsMenuOpen(true);
      setWillMenuClose(false);
    }
  };
  const changeBackground = () => {
    if (location.pathname !== "/") return;
    if (window.scrollY >= 80) {
      setNavbarChange(true);
    } else {
      setNavbarChange(false);
    }
    // console.log(window.scrollY);
  };

  useEffect(() => {
    getCategories();
    window.addEventListener("scroll", changeBackground);
    return () => window.removeEventListener("scroll", changeBackground);
  }, []);

  return (
    <>
      {isMenuOpen && (
        <Menu categories={categories} willItClose={willMenuClose} setIsOpen={setIsMenuOpen} />
      )}
      <header className="header_section">
        <div className="container-fluid scrollColor">
          <Navbar
            fixed="top"
            id="container-navbar"
            className={
              navbarChange
                ? "navbarChange active custom_nav-container container-fluid"
                : "navbarChange custom_nav-container container-fluid"
            }
            expand={false}
          >
            <Container fluid>
              <Link className="navbar-brand siteIcon text-white fw-bold fs-5" to="/">
                SUPERPOWER
                <i className="bi bi-lightning-fill text-white"></i>
              </Link>
              <Link className="navbar-brand" to="/">
                <i className="bi bi-lightning-fill text-white siteIconRes pe-3 fs-5"></i>
              </Link>
              <div className="navbar-icon">
                {customer ? (
                  <span className="position-relative">
                    <i
                      className="fa fa-user"
                      style={{ cursor: "pointer" }}
                      aria-hidden="true"
                      onClick={toggleCustomerDropdown}
                    ></i>
                    {customerDropdown && (
                      <div className="customer-dropdown">
                        <div className="rounded bg-light shadow px-1">
                          <p className="text-muted pt-2 mb-1">You are registered as:</p>
                          <p className="fw-bold mb-1">
                            {customer.firstname + " " + customer.lastname}
                          </p>
                          <hr className="my-2"></hr>
                          <Link to="/my-orders" className="customer-dropdown-option">
                            <i className="pe-2 fa-solid fa-arrow-right"></i>
                            Go to my orders
                          </Link>
                          <hr className="my-2"></hr>
                          <Link to="/edit-my-info" className="customer-dropdown-option">
                            <i className="pe-2 fa-solid fa-arrow-right"></i>
                            Edit my information
                          </Link>
                          <hr className="my-2"></hr>
                          <p className="customer-dropdown-option pb-2" onClick={logout}>
                            <i className="pe-2 fa-solid fa-arrow-right"></i>
                            Logout
                          </p>
                        </div>
                      </div>
                    )}
                  </span>
                ) : (
                  <Link to="/login">
                    <i className="fa fa-user" aria-hidden="true"></i>
                  </Link>
                )}
              </div>
              <div className="position-relative navbar-icon" onClick={openShoppingCart}>
                <i style={{ cursor: "pointer" }} className="fas fa-shopping-cart"></i>

                {shoppingCartSize > 0 && (
                  <div className="shopping-cart-globe text-center">{shoppingCartSize}</div>
                )}
              </div>
              <div className="User_option navbar-icon">
                <div className="justify-content-end"></div>
              </div>

              <div className="position-relative">
                <span
                  className={`text-light fs-2 menu-icon open ${
                    isMenuOpen ? (willMenuClose ? "appears" : "vanishes") : "static"
                  }`}
                  onClick={toggleMenu}
                >
                  <i className="fa-solid fa-bars"></i>
                </span>
                {isMenuOpen && (
                  <span
                    className={`text-light fs-2 pb-2 menu-icon close ${
                      willMenuClose ? "vanishes" : "appears"
                    }`}
                    onClick={toggleMenu}
                  >
                    <i className="bi bi-x-lg"></i>
                  </span>
                )}
              </div>

              <Navbar.Offcanvas
                id="offcanvasNavbar"
                aria-labelledby="offcanvasNavbarLabel"
                placement="end"
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title id="offcanvasNavbarLabel">Offcanvas</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <Nav className="justify-content-end flex-grow-1 pe-3">
                    <Nav.Link href="/">Home</Nav.Link>
                    <Nav.Link href="/about">About</Nav.Link>
                    <Nav.Link href="/categories/suplements">Supplements</Nav.Link>
                    <Nav.Link href="/categories/protein-bars">Protein Bars</Nav.Link>
                    <Nav.Link href="/categories/isotonic-drinks">Isotonic Drinks</Nav.Link>
                    <Nav.Link href="/contact">Contact Us</Nav.Link>
                  </Nav>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </Container>
          </Navbar>
        </div>
      </header>
    </>
  );
}
